import { getAmplitudeVariantPayload } from './utils/amplitudeCommon';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-underscore-dangle
  const state = window.__PRELOADED_STATE__ || {};
  const fallback = (state.flags && state.flags.rum_integration_config) || {};
  const resolved = getAmplitudeVariantPayload('rum_integration_config', state, fallback);
  const rumConfig = resolved && typeof resolved === 'object' ? resolved : fallback || {};

  if (rumConfig && rumConfig.enable) {
    import('hcmprum').then(({ initializeOpenTelemetry }) => {
      initializeOpenTelemetry({
        serviceName: rumConfig.serviceName,
        collectorUrl: rumConfig.collectorUrl,
        routingRum: rumConfig.routingRum,
        assetId: rumConfig.assetId
      });
    });
  }
}
